import { ReactNode } from "react"
import styled from "styled-components"
import { v4 as uuidv4 } from "uuid"

import { Spinner } from "components/common/Spinner"
import { Tooltip } from "components/common/Tooltip"

const StatCardWrapper = styled.div`
  flex: 1 1 0;
  min-width: 200px;
  background: #ffffff;
  border-radius: 20px;
  padding: 20px 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`

const StatCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
`

const TooltipWrapper = styled.div`
  margin-left: auto;
`

const StatCardTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
  line-height: 24px;
  margin-right: 6px;
`

const StatCardValue = styled.div`
  font-size: 40px;
  font-weight: 500;
  color: #0f172a;
  display: flex;
  align-items: center;
`

const StyledTooltip = styled(Tooltip)<{ $tooltipMaxWidth?: number }>`
  span {
    &:after {
      transform: scale(1.4);
      display: inline-block;
      top: 1px;
    }
  }

  div {
    max-width: ${p => p.$tooltipMaxWidth ?? 140}px;
    text-align: center;
    z-index: 2100;
  }
`

interface StatCardProps {
  title: string
  value: number
  infoTooltip?: string
  tooltipMaxWidth?: number
  isLoading?: boolean
  content?: ReactNode
}

export const StatCard = ({ title, value, infoTooltip, tooltipMaxWidth, isLoading, content }: StatCardProps) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <StatCardValue>
          <Spinner justifyContent="flex-start" />
        </StatCardValue>
      )
    }

    if (content) {
      return content
    }

    return <StatCardValue>{value.toLocaleString()}</StatCardValue>
  }

  return (
    <StatCardWrapper>
      <StatCardHeader>
        <StatCardTitle>{title}</StatCardTitle>
        {infoTooltip && (
          <TooltipWrapper>
            <StyledTooltip id={uuidv4()} text={" "} orientation="top" $tooltipMaxWidth={tooltipMaxWidth}>
              {infoTooltip}
            </StyledTooltip>
          </TooltipWrapper>
        )}
      </StatCardHeader>
      {renderContent()}
    </StatCardWrapper>
  )
}
